import { CustomEventUtils, Utils } from '@pacem/pacem-core';
import { Point } from '@pacem/pacem-foundation';
import { isCamera } from '../types';
function _clipPoint(evt, rect) {
    let x, y;
    if (Point.isPoint(evt)) {
        x = evt.x;
        y = evt.y;
    }
    else {
        const { page } = CustomEventUtils.getEventCoordinates(evt);
        const p = { x: page.x - rect.x, y: page.y - rect.y };
        x = p.x;
        y = p.y;
    }
    const clipX = x / rect.width * 2 - 1;
    const clipY = y / rect.height * -2 + 1;
    return { x: clipX, y: clipY };
}
export class AdapterUtils {
    static isMeshGeometry(obj) {
        return 'positions' in obj && Utils.isArray(obj.positions)
            && 'triangleIndices' in obj && Utils.isArray(obj.triangleIndices);
    }
    static isVector3D(obj) {
        return 'x' in obj && typeof obj.x === 'number'
            && 'y' in obj && typeof obj.y === 'number'
            && 'z' in obj && typeof obj.z === 'number';
    }
    static isRgba(obj) {
        return 'r' in obj && typeof obj.r === 'number'
            && 'g' in obj && typeof obj.g === 'number'
            && 'b' in obj && typeof obj.b === 'number';
    }
    static flattenVectorArray(array) {
        const retval = [];
        for (let v of array) {
            if (AdapterUtils.isVector3D(v)) {
                retval.push(v.x, v.y, v.z);
            }
            else if (AdapterUtils.isRgba(v)) {
                retval.push(v.r, v.g, v.b, v.a ?? 1);
            }
            else {
                retval.push(v.x, v.y);
            }
        }
        return retval;
    }
    static findCamera(items) {
        return (items || []).find(r => isCamera(r) && !r.hide);
    }
    clipPixel(evt, viewport) {
        if (viewport instanceof HTMLElement) {
            viewport = Utils.offsetRect(viewport);
        }
        return _clipPoint(evt, viewport);
    }
}
